module.exports = __webpack_public_path__ + "img/brochure.1247e967.png";